/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleDeviceIssuesResponse } from './equipment-schedule-device-issues-response';
import { EquipmentScheduleChangeStatuses } from './equipment-schedule-change-statuses';


export interface EquipmentScheduleAssignmentChangeResponse { 
    status?: EquipmentScheduleChangeStatuses;
    matchedCount?: number;
    excludedCount?: number;
    assignedCount?: number;
    enabledCount?: number;
    disabledCount?: number;
    unassignedCount?: number;
    replacedCount?: number;
    alreadyAssignedCount?: number;
    devices?: Array<EquipmentScheduleDeviceIssuesResponse> | null;
}



